export const getUrlWithParams = (url, queryParams) => {
  const params = new URLSearchParams();
  Object.entries(queryParams).forEach(_ref => {
    let key = _ref[0],
      value = _ref[1];
    if (value !== undefined && value !== null) {
      const valueArray = Array.isArray(value) ? value : [value];
      valueArray.forEach(val => {
        params.append(key, val);
      });
    }
  });
  const query = params.toString();
  if (query.length > 0) {
    return `${url}?${query}`;
  }
  return url;
};
export function extractResult(result) {
  return result.status === 'fulfilled' ? result.value : undefined;
}
//# sourceMappingURL=utils.js.map